<template>

  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative min-height" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">

      <div class="container-fluid custom-container">

        <!-- Packages Start -->
        <div class="section section-padding mt-n10 padding-top-50">
          <div class="container row gx-12">

            <div class="col-lg-6">
              <!-- Courses Resources Start -->
              <div class="courses-resources user-home widget-information">
                <h4 class="title">Which test do you want to attempt?</h4>

                <!-- Resources Wrapper Start -->
                <div class="resources-wrapper">
                  <div class="row row-cols-xl-2 row-cols-md-3 row-cols-2">
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <a class="cursor-pointer" @click="gotoTestEnv('practice')">
                            <img src="/assets/images/resources-icon/icon-1-3.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-3.png" alt="Icon">
                          </a>
                        </div>
                        <h5 class="title mt-5 cursor-pointer"><span @click="gotoTestEnv('practice')">Practice Test</span></h5>
                      </div>
                      <!-- Single Resources End -->

                    </div>
                    <div class="col">

                      <!-- Single Resources Start -->
                      <div class="single-resources">
                        <div class="resources-icon">
                          <a class="cursor-pointer" @click="gotoTestEnv('mock')">
                            <img src="/assets/images/resources-icon/icon-1-4.png" alt="Icon">
                            <img class="hover" src="/assets/images/resources-icon/icon-2-4.png" alt="Icon">
                          </a>
                        </div>
                        <h5 class="title mt-5 cursor-pointer"><span @click="gotoTestEnv('mock')">Final Test</span></h5>
                      </div>
                      <!-- Single Resources End -->

                    </div>
                  </div>
                </div>
                <!-- Resources Wrapper End -->

              </div>
              <!-- Courses Resources End -->
            </div>

            <div class="col-lg-6">
              <!-- Courses Resources Start -->
              <div class="courses-resources user-home widget-information">
                <h4 class="title">Notes:</h4>
                <ul>
                  <li> 1. Final test is time bound and practice test has no time limit </li>
                  <li> 2. You can check correct answer during the test in practice test </li>
                  <li> 3. You can check result of the Final test on this page anytime </li>
                  <li> 4. Number of questions in test is based on the package subscribed </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <!-- Packages End -->

        <!-- Admin Courses Tab Content Start -->
        <div class="admin-courses-tab-content">
          <h3 class="title">Final Test Records</h3><br />

          <div class="tab-content" v-for='(result, index) in results' :key='result._id'>
            <div class="tab-pane fade show active" id="tab1">

              <!-- Courses Item Start -->
              <div class="courses-item padding-12 margin-12">
                <div class="content-title">
                  <h3 class="title"><a href="#" class="margin-top-0">Final Test {{index+1}}</a></h3>
                </div>
                <div class="content-wrapper">
                  <div class="message-form margin-top-0">
                    <div class="message-input">
                      <div class="message-btn button-width margin-top-0">
                        <p class="btn btn-secondary font-weight-bold">Date Attempted: {{formatDate(result.test_attempt_date)}}</p>
                        <p class="btn btn-secondary font-weight-bold">Score: {{ result.correct_ans }} / {{result.result_length}}</p>
                        <a @click='showSummary(result)' class="btn btn-primary btn-hover-dark">View Summary</a>
                        <a @click='gotoRsults(result._id)' class="btn btn-primary btn-hover-dark">View Test Result</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Courses Item End -->

            </div>
          </div>
        </div>
        <!-- Admin Courses Tab Content End -->

      </div>

    </div>
    <!-- Page Content Wrapper End -->

    <!-- Summary Modal -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Incorrect Answers - Rules</h3>
          <button class="close-btn" @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">

          <!-- Loading State -->
          <div v-if="loadingRules" class="loading-state">
            <div class="spinner"></div>
            <p>Loading incorrect rules...</p>
          </div>

          <!-- Rules Content -->
          <div v-else-if="incorrectRules.length > 0">
            <p class="modal-info">
              Test Date: <strong>{{ selectedTestDate }}</strong><br>
              Score: <strong>{{ selectedScore }}</strong>
            </p>
            <div class="rules-section">
              <h4>Rules to Review:</h4>
              <div class="rules-list">
                <div
                  v-for="rule in incorrectRules"
                  :key="rule.ruleId"
                  class="rule-item"
                >
                  <span class="rule-id">{{ formatRuleText(rule.ruleId) }}</span>
                  <span class="rule-desc" v-if="rule.description">{{ formatRuleText(rule.description) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Error State -->
          <div v-else-if="rulesError" class="error-state">
            <p>{{ rulesError }}</p>
          </div>

          <!-- No Data State -->
          <div v-else class="no-data-state">
            <p>No incorrect rules found.</p>
          </div>

        </div>
      </div>
    </div>
    <!-- End Summary Modal -->

    <!-- Free Trial / Package Required Modal -->
    <div v-if="showFreeTrialModal" class="modal-overlay" @click="closeFreeTrialModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Package Required</h3>
          <button class="close-btn" @click="closeFreeTrialModal">&times;</button>
        </div>
        <div class="modal-body">
          <p>You are currently on the free trial. The Final Test is only available once you purchase a package.</p>
          <p>You can still take the Practice Test for free — purchase a package to unlock the Final Test.</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeFreeTrialModal">Cancel</button>
          <button class="btn btn-primary" @click="goPurchasePackage">View Packages</button>
        </div>
      </div>
    </div>
    <!-- End Free Trial / Package Required Modal -->

  </div>
</template>

<script>
import { jwtDecode } from "jwt-decode";
import { getUserPackageDetails } from '@/services/subscriptionService';
import { fetchLatestTestResults } from '@/services/resultService';
import { getIncorrectRules } from '@/services/bulkUserService';

export default {
  name: 'ManageTest',
  data() {
    return {
      token_info: null,
      user_pkg: null,
      results: null,
      // Modal state
      showModal: false,
      loadingRules: false,
      incorrectRules: [],
      rulesError: null,
      selectedTestDate: '',
      selectedScore: '',
      showFreeTrialModal: false,
    }
  },

  mounted() {
    const decoded = jwtDecode(localStorage.getItem('access_token'));
    this.token_info = decoded;
    this.getUserPackageDetail();
    this.get_results();
  },

  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    },

    gotoRsults(id) {
      this.$router.push(`test-results/${id}`);
    },

    gotoTestEnv(test_type) {
      const hasActivePackage = !!(this.user_pkg && this.user_pkg.sub_id);

      // Final Test requires a purchased package — free trial users get a
      // popup instead of being allowed into the test.
      if (test_type === 'mock' && !hasActivePackage) {
        this.showFreeTrialModal = true;
        return;
      }

      if (hasActivePackage) {
        this.$router.push(`mock-test/${this.user_pkg.sub_id}/${this.token_info.id}/${test_type}`);
      } else {
        this.$router.push(`mock-test/free/${this.token_info.id}/${test_type}`);
      }
    },

    closeFreeTrialModal() {
      this.showFreeTrialModal = false;
    },

    goPurchasePackage() {
      this.showFreeTrialModal = false;
      this.$router.push('/dashboard/user/home');
    },

    async getUserPackageDetail() {
      try {
        const res = await getUserPackageDetails(this.token_info.id);
        this.user_pkg = res.data;
        console.log('User package:', this.user_pkg);
        if (this.user_pkg && this.user_pkg.is_org_package) {
          console.log('Using organization package from manager:', this.user_pkg.manager_email);
        }
      } catch (error) {
        console.error('Error fetching user package:', error);
        this.user_pkg = null;
      }
    },

    async get_results() {
      try {
        this.results = await fetchLatestTestResults(this.token_info.id);
        console.log('Test results:', this.results);
      } catch (error) {
        console.error('Error fetching test results:', error);
        this.results = [];
      }
    },

    async showSummary(result) {
      this.showModal = true;
      this.loadingRules = true;
      this.incorrectRules = [];
      this.rulesError = null;
      this.selectedTestDate = this.formatDate(result.test_attempt_date);
      this.selectedScore = `${result.correct_ans} / ${result.result_length}`;

      try {
        const response = await getIncorrectRules(result._id);
        this.incorrectRules = response.data.incorrectRules;
      } catch (error) {
        console.error('Error fetching incorrect rules:', error);
        this.rulesError = 'Failed to load incorrect rules. Please try again.';
      } finally {
        this.loadingRules = false;
      }
    },

    formatRuleText(text) {
      if (!text) return '';
      // Display only, does not affect stored data: strip trailing sub-clause references like (a), (b), (c)
      return text.replace(/\s*\([a-z]\)\.?/gi, '').trim();
    },

    closeModal() {
      this.showModal = false;
      this.incorrectRules = [];
      this.rulesError = null;
      this.selectedTestDate = '';
      this.selectedScore = '';
    }
  }
}
</script>

<style scoped>
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #212832;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  line-height: 1;
  padding: 0;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Loading Spinner */
.loading-state {
  text-align: center;
  padding: 40px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #309255;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Modal Info */
.modal-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  line-height: 1.8;
  font-size: 14px;
  color: #52565b;
}

/* Rules Section */
.rules-section h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #212832;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rule-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 15px;
}

.rule-id {
  background: #309255;
  color: white;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  min-width: 90px;
  text-align: center;
}

.rule-desc {
  font-size: 14px;
  color: #52565b;
  font-weight: 400;
}

/* Error / No Data */
.error-state,
.no-data-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

/* Final Test Record row - responsive button/pill group */
.message-form .message-input .message-btn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.message-form .message-input .message-btn .btn {
  margin: 0;
}

@media only screen and (max-width: 767px) {
  .message-form .message-input .message-btn {
    flex-direction: column;
    align-items: stretch;
    margin-top: 15px;
  }

  .message-form .message-input .message-btn .btn {
    width: 100%;
    height: auto;
    line-height: normal;
    padding: 12px 16px;
    font-size: 14px;
    white-space: normal;
  }
}
</style>